// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1X5ic","detailsBorder":"styles_detailsBorder__5LwR9"};